import React from 'react';

// eslint-disable-next-line max-len
const MONUMENTAL_LOGO = '/themes/theme/monumental/logo.png';

const MonumentalTheme = {
  headerLogo: {
    src: MONUMENTAL_LOGO,
    alt: 'Monumental Logo',
    size: 30,
  },
  darkLogo: {
    src: MONUMENTAL_LOGO,
    alt: 'Monumental Logo',
    size: 30,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#F2E3AB',
    borderBottom: '4px solid #000',
    height: 80,
  },
  title: 'Monumental',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="30"
        src={MONUMENTAL_LOGO} alt="Monumental Logo"
      />
      <br /><br />
      <h3>Monumental</h3>
    </div>
  ),
  shareSite: 'https://reports.monumentalmarketing.co.uk',
};

export default MonumentalTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/monumental.js
 **/